import store from '../../store/store'

import('./timer_selector.scss')

export default function TimerSelector(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    let currentSelected
    let optionsList = []
    let optionsListObj = {}
    let hideOnes = []
    let currentToggle = true
    let customDate = false
    let timer_options = ['1','2','3','12','24','48','72', 'data personalizada']

    this.generate = () =>{
        elements.container = this.createElement('div', 'map-timer-selector-container')
        elements.title = this.createElement('div', 'map-timer-selector-title')
        elements.list_container = this.createElement('div', 'map-timer-selector-list-container')
        elements.date_selector = this.createElement('div', 'map-timer-selector-date-selector')
        
        $(elements.title).html("<i class='far fa-clock'></i>")

        $(elements.container).append(elements.title, elements.list_container)
        $(container).append(elements.container)

        generateTimers()
        generateDateSelector()
        let indexOf = 4
        if(localStorage.getItem('sibh_raining_now_hours')){
            indexOf = timer_options.indexOf(localStorage.getItem('sibh_raining_now_hours'))
            indexOf = indexOf < 0 ? 4 : indexOf
        }

        optionsList[indexOf].select(true)
        currentSelected = optionsList[indexOf]

        

        $(elements.title).on('click', _=>{
            currentToggle = !currentToggle
            this.toggleContainer()
        })
        
        setTimeout(_=>{
            this.toggleContainer()
        },300)

    }

    this.update = () =>{
        
    }

    this.hideOptions = values =>{
        hideOnes = values
        // values.map(value=>{
        //     optionsListObj[value].hide()
        // })
        this.toggleContainer()
    }

    this.toggleContainer = _ =>{

        if(currentToggle){
            $.each(optionsListObj, (value, option)=>{
                if(!hideOnes.includes(parseInt(value))){
                    option.show()
                } else {
                    option.hide()
                }
            })
            if(store.mainConfigStore.getType() === 'plu'){
                $([...elements.list_container.childNodes].filter(el=>$(el).hasClass('custom-date'))[0]).hasClass('selected') ? $('.map-timer-selector-date-selector').css('display', 'flex') : $('.map-timer-selector-date-selector').css('display', 'none')
            }

        } else {
            Object.values(optionsListObj).map(option=>$(option.getElement()).css('display', $(option.getElement()).hasClass('map-timer-selector-option selected') ? 'flex' : 'none'))
        }

        let height = currentToggle ? [...elements.list_container.childNodes].reduce((a,c) => a += c.offsetHeight,0) : [...elements.list_container.childNodes].filter(el=>$(el).hasClass('selected'))[0].offsetHeight
        
        $(elements.list_container).height(height)
    }

    this.select = value =>{
        if(value != 'data personalizada'){
            if(!currentSelected || currentSelected.getValue() != value){
                currentSelected.select(false)
                
                currentSelected = optionsListObj[value]

                store.mainConfigStore.setHours(value)    
                currentToggle = false
            } else {
                currentToggle = true
            }

            context.toggleContainer()      
            

        } else {
            //controle de seleção de custom date
            customDate = !customDate

            //toggle no seletor no caso de clicks multiplos
            optionsListObj[value].select(customDate)

            //toggle no input
            $(elements.date_selector).toggle(customDate)

            //limpando a data no store
            store.mainConfigStore.setDate(undefined)

            //limpando a data selecionada
            elements.date_selector.value = ''
        }
    }

    const generateTimers = _=>{
        timer_options.forEach(time=>{
            let option = new Option({hour: time})
            $(option).on('click', (e,data) =>{
                context.select(data.value)
                this.toggleContainer()
            })
            $(elements.list_container).append(option.getElement())
            

            optionsList.push(option)
            optionsListObj[time] = option
        })
    }

    const generateDateSelector = _ =>{
        $(elements.date_selector).append('<input type="datetime-local"></input>')
        $(elements.list_container).append(elements.date_selector)
        $(elements.date_selector).toggle(false)
        $(elements.date_selector).on('change', e=>{
            store.mainConfigStore.setDate(e.target.value)
        })
    }
}


function Option(opts = {}){
    let {hour} = opts
    let elements = {}
    let context = this

    this.getElement = _ =>{
        return elements.container
    }

    this.select = boolean =>{
        $(elements.container).toggleClass('selected', boolean)
    }
    
    this.hide = _=>{
        $(this.getElement()).css('display', 'none')
    }

    this.show = _=>{
        $(this.getElement()).css('display', 'flex')
    }

    this.getValue = _=> hour

    init()

    function init(){
        elements.container = document.createElement('div')
        $(elements.container).addClass('map-timer-selector-option')

        elements.container.innerHTML =  `${hour}${!isNaN(hour) ? `h` : '' } `

        if(hour == 'data personalizada'){
            $(elements.container).addClass('custom-date')
            $(elements.container).html('<i class="fas fa-calendar-alt"></i>')
        }

        $(elements.container).on('click', _=>{
            context.select(true)
            $(context).trigger('click', {value:hour})
        })
    }
}

TimerSelector.prototype = Object.create(BaseConstructor.prototype)